import { type FC } from "react";

import { QuestionList, QuestionRow } from "@styled/question_row";
import { SectionLabel } from "@styled/section_label";

// A new chat's body: what this assistant does, then its questions.
export const SuggestedQuestionsList: FC<{
  descriptor: string;
  questions: string[];
  disabled: boolean;
  onAsk(question: string): void;
}> = ({ descriptor, questions, disabled, onAsk }) => (
  <>
    <p>{descriptor}</p>
    {questions.length > 0 && (
      <>
        <SectionLabel size="xs">Suggested questions</SectionLabel>
        <QuestionList>
          {questions.map((question) => (
            <QuestionRow
              key={question}
              disabled={disabled}
              onClick={() => onAsk(question)}
            >
              {question}
            </QuestionRow>
          ))}
        </QuestionList>
      </>
    )}
  </>
);
